import { render, staticRenderFns } from "./SearchInput.vue?vue&type=template&id=b0b0fe36&scoped=true&"
import script from "./SearchInput.vue?vue&type=script&lang=ts&"
export * from "./SearchInput.vue?vue&type=script&lang=ts&"
import style0 from "./SearchInput.vue?vue&type=style&index=0&id=b0b0fe36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0b0fe36",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/brilliant/brilliant/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('b0b0fe36', component.options)
    } else {
      api.reload('b0b0fe36', component.options)
    }
    module.hot.accept("./SearchInput.vue?vue&type=template&id=b0b0fe36&scoped=true&", function () {
      api.rerender('b0b0fe36', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/components/search/SearchInput.vue"
export default component.exports